import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import uiData from "./data.json";

const ReportForm = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const handleChange = (label, value) => {
    setFormData({ ...formData, [label]: value });
  };

  const handleAction = (action) => {
    if (action === "back") {
      navigate("/dashboard");
    } else if (action === "print") {
      window.print();
    } else {
      alert(`${action} clicked`);
    }
  };

  return (
    <div className="bg-gray-200 min-h-screen flex justify-center items-center p-4 sm:p-6">
      <div className="bg-gradient-to-b from-slate-400 to-slate-500 shadow-lg border border-gray-500 rounded-lg w-full max-w-3xl">
        <div className="bg-gradient-to-r from-gray-500 to-gray-600 text-white text-center py-3 rounded-t-lg">
          <h1 className="text-lg sm:text-xl font-bold">{uiData.title}</h1>
          <p className="text-xs sm:text-sm">{uiData.subtitle}</p>
        </div>

        <div className="p-3 border-b border-gray-500 text-center">
          <h2 className="text-base sm:text-lg font-semibold">{uiData.reportTitle}</h2>
        </div>

        <div className="p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {uiData.fields.map((field, index) => (
            <div key={index} className="flex flex-col">
              <label className="text-gray-800 font-medium mb-1 text-sm sm:text-base">
                {field.label} :
              </label>

              {field.type === "select" ? (
                <select
                  onChange={(e) => handleChange(field.label, e.target.value)}
                  className="border border-gray-400 rounded-md px-3 py-2 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  {field.options.map((opt, i) => (
                    <option key={i}>{opt}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type}
                  defaultValue={field.default || ""}
                  onChange={(e) => handleChange(field.label, e.target.value)}
                  className="border border-gray-400 rounded-md px-3 py-2 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              )}
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 py-4 px-4">
          {uiData.buttons.map((btn, i) => (
            <button
              key={i}
              className="bg-blue-700 hover:bg-blue-800 text-white px-4 sm:px-6 py-2 rounded-md shadow-md font-semibold text-sm sm:text-base"
              onClick={() => handleAction(btn.action)}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportForm;